import React from "react";

const iconPaths = {
  create: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M12 5.25v13.5m6.75-6.75H5.25"
    />
  ),
  edit: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </>
  ),
  delete: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M4.5 7.5h15"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M9.75 10.5v5.25M14.25 10.5v5.25M6.75 7.5l.621 10.562A1.5 1.5 0 008.868 19.5h6.264a1.5 1.5 0 001.497-1.438L17.25 7.5M9 7.5V5.25A.75.75 0 019.75 4.5h4.5a.75.75 0 01.75.75V7.5"
      />
    </>
  ),
  view: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M2.25 12s3.75-6.75 9.75-6.75S21.75 12 21.75 12 18 18.75 12 18.75 2.25 12 2.25 12z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M12 15.75A3.75 3.75 0 1012 8.25a3.75 3.75 0 000 7.5z"
      />
    </>
  ),
  toggleChecked: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M9 11.25l2.25 2.25L15 9.75"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M9 5.25h6A3.75 3.75 0 0118.75 9v6A3.75 3.75 0 0115 18.75H9A3.75 3.75 0 015.25 15V9A3.75 3.75 0 019 5.25z"
      />
    </>
  ),
  toggleUnchecked: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M9 5.25h6A3.75 3.75 0 0118.75 9v6A3.75 3.75 0 0115 18.75H9A3.75 3.75 0 015.25 15V9A3.75 3.75 0 019 5.25z"
    />
  ),
};

const getIconMarkup = (icon, checked) => {
  if (icon === "toggle") {
    return checked ? iconPaths.toggleChecked : iconPaths.toggleUnchecked;
  }
  return iconPaths[icon] || iconPaths.edit;
};

const toneClasses = {
  primary:
    "text-[#4f46e5] hover:bg-indigo-50 hover:text-[#4338ca] focus-visible:outline-[#4f46e5]",
  danger:
    "text-rose-600 hover:bg-rose-50 hover:text-rose-700 focus-visible:outline-rose-500",
  neutral:
    "text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus-visible:outline-slate-400",
  success:
    "text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700 focus-visible:outline-emerald-500",
};

const ActionButton = ({
  label,
  icon = "edit",
  tone = "primary",
  checked = false,
  className = "",
  ...props
}) => {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      aria-pressed={icon === "toggle" ? checked : undefined}
      className={[
        "inline-flex items-center justify-center rounded-md p-1.5 text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        toneClasses[tone] || toneClasses.primary,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      <svg
        className="h-4 w-4 shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        {getIconMarkup(icon, checked)}
      </svg>
    </button>
  );
};

export default ActionButton;
